import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'

interface ConversationHeaderProps {
  agentName?: string
  imageUrl?: string
}

const ConversationHeader = ({ agentName = 'Léa', imageUrl = '' }: ConversationHeaderProps): JSX.Element => {
  const locale = useSelector((state: RootState) => state.localeReducer.localeForRetorikStudioContent)
  const localizedCompanyName = useSelector((state: RootState) => state.localeReducer.localizedCompanyName)
  const localizedSubCompanyMessage = useSelector((state: RootState) => state.localeReducer.localizedSubCompanyMessage)
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)
  const configuration = useSelector((state: RootState) => state.retorikReducer.configuration)
  const themeColors = useSelector((state: RootState) => state.viewReducer.themeColors)

  const [finalCompanyName, setFinalCompanyName] = useState<string | undefined>()
  const [finalSubCompanyMessage, setFinalSubCompanyMessage] = useState<string | undefined>()

  const processedCompanyName = useMemo<string | undefined>(() => {
    return configuration.companyNameLocalized?.[locale] || localizedCompanyName || configuration.companyName
  }, [locale, localizedCompanyName, configuration.companyName, configuration.companyNameLocalized])

  const processedSubCompanyMessage = useMemo<string | undefined>(() => {
    return configuration.subCompanyMessageLocalized?.[locale] || localizedSubCompanyMessage || configuration.subCompanyMessage
  }, [locale, localizedSubCompanyMessage, configuration.subCompanyMessage, configuration.subCompanyMessageLocalized])

  useEffect(() => {
    // If either companyName or subCompanyMessage is given, let's use both. Use default is none is given.
    if (processedCompanyName || processedSubCompanyMessage) {
      setFinalCompanyName(processedCompanyName)
      setFinalSubCompanyMessage(processedSubCompanyMessage)
    } else {
      setFinalCompanyName('Davi')
      setFinalSubCompanyMessage(`${agentName} ${translation.menu.answer}`)
    }
  }, [processedCompanyName, processedSubCompanyMessage])

  return (
    <div id='retorik-conversation-header' className='rf-w-full rf-h-fit rf-grid rf-grid-cols-headerContainer rf-grid-rows-headerContainer rf-bg-truewhite rf-bg-opacity-80'>
      {/* Avatar */}
      <div className='rf-col-start-1 rf-col-end-2 rf-row-start-1 rf-row-end-3 rf-flex rf-items-center rf-px-2 rf-py-2'>
        <img src={imageUrl} alt='Agent' className='rf-w-full rf-max-h-20 rf-aspect-square rf-rounded-half rf-border-secondary rf-border-2 rf-bg-truewhite' />
      </div>

      {/* Agent Title + Company */}
      <div className='rf-col-start-3 rf-col-span-full rf-row-start-1 rf-row-span-full rf-flex rf-flex-col rf-justify-center'>
        {/* Company */}
        {finalCompanyName && (
          <div
            className='rf-font-bold rf-leading-4'
            style={{
              color: themeColors.companyName
            }}
          >
            {finalCompanyName}
          </div>
        )}

        {/* Agent Title */}
        {finalSubCompanyMessage && <div className='rf-text-sm/4 rf-italic'>{finalSubCompanyMessage}</div>}
      </div>
    </div>
  )
}

export default ConversationHeader
